const BadLink = () => {
    return(
        <main>This link cannot be found. Did you mistype?</main>
    );
}

export default BadLink;